import { connect } from 'react-redux';
import { compose, withProps } from 'recompose';
import { withRouter } from 'react-router-dom';
import { withStyles } from '@material-ui/core/styles';
import {
  closeReviewContentView,
  openDispute
} from '../../../store/actions/dealActions';
import { withFirestore } from 'react-redux-firebase';
import { acceptContentAndReleaseFunds } from './../../../store/actions/paymentsActions';

const styles = theme => ({
  root: {
    width: 550,
    height: '100%',
    [theme.breakpoints.down('xs')]: {
      width: 350
    },
    padding: '20px'
  },
  videoContainer: {
    maxWidth: '400px',
    maxHeight: '400px'
  },
  acceptButton: {
    marginBottom: '30px',
    color: 'white'
  },
  youtubeVideoUpload: {
    position: 'relative',
    paddingBottom: '56.25%',
    paddingTop: '30px',
    height: '0',
    overflow: 'hidden',
    '& iframe': {}
  },
  iframeContainer: {
    position: 'absolute',
    top: '0',
    left: '0',
    width: '100%',
    height: '100%'
  },
  contentLink: {
    marginTop: '20px',
    marginBottom: '20px'
  },
  buttonContainer: {
    marginTop: '40px',
    textAlign: 'center',
    marginBottom: '40px'
  },
  spinnerContainer: {
    position: 'absolute',
    width: '100%',
    height: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyItems: 'center',
    background: 'white',
    zIndex: '1000',
    opacity: '.5'
  },
  downArrow: {
    display: 'block',
    margin: '0 auto'
  },
  contentContainer: {
    padding: '10px',
    marginTop: '30px'
  },
  contentLink: {
    color: 'black !important'
  },
  spinnerContainer: {
    position: 'fixed',
    width: '100%',
    height: '100%',
    background: 'white',
    zIndex: '999',
    opacity: '.5'
  },
  downArrow: {
    position: 'fixed',
    left: '50%',
    top: '50%',
    zIndex: '1000'
  }
});

const mapStateToProps = state => {
  return {
    auth: state.firebase.auth,
    open: state.dealState.viewReviewContent,
    deal: state.dealState.dealWithContent,
    escrowReleaseIsProcessing: state.payments.escrowReleaseIsProcessing
  };
};

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    closeClick: () => dispatch(closeReviewContentView()),
    acceptContent: (paymentId, amount, influencerId, uid, dealId, onComplete) =>
      dispatch(
        acceptContentAndReleaseFunds(
          paymentId,
          amount,
          influencerId,
          uid,
          dealId
        )
      )
        .then(() => {
          onComplete();
        })
        .catch(() => {
          onComplete();
        }),
    handleOpenDispute: (dealId, uid) => dispatch(openDispute(dealId, uid))
  };
};

export default compose(
  connect(
    mapStateToProps,
    mapDispatchToProps
  ),
  withFirestore,
  withProps(({ auth }) => ({
    auth
  })),
  withRouter,
  withStyles(styles)
);



// WEBPACK FOOTER //
// ./src/components/deals/content-review/ReviewContent.enhancer.js